import { render, staticRenderFns } from "./r-guard-rules.vue?vue&type=template&id=29faaabf"
import script from "./r-guard-rules.vue?vue&type=script&lang=js"
export * from "./r-guard-rules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29faaabf')) {
      api.createRecord('29faaabf', component.options)
    } else {
      api.reload('29faaabf', component.options)
    }
    module.hot.accept("./r-guard-rules.vue?vue&type=template&id=29faaabf", function () {
      api.rerender('29faaabf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/guard/r-guard-rules.vue"
export default component.exports